/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react'
import {
  Box, CouponError, CouponValid, IcoMoon,
} from '@usap/uicomponents'
import {
  ApplyButton, CouponInputContainerEmpty, CouponInputContainerError, CouponInputContainerValid, CouponTextInput,
} from './CouponInputWmo.css'

const getContainer = (hasError, isValidCoupon) => {
  if (hasError) {
    return CouponInputContainerError
  }

  if (isValidCoupon) {
    return CouponInputContainerValid
  }

  return CouponInputContainerEmpty
}

const getIcon = (hasError, isValidCoupon) => {
  if (hasError) {
    return (
      <IcoMoon
        icon={CouponError}
        color="#CC3333"
        size="24px"
      />
    )
  }

  if (isValidCoupon) {
    return (
      <IcoMoon
        icon={CouponValid}
        color="#669944"
        size="24px"
      />
    )
  }

  return null
}

const CouponFullInputWmo = ({
  coupon, keyUpHandler, changeHandler, isCouponEmpty, applyCoupon, hasError, isValidCoupon, isTyping, setIsTyping,
}) => {
  const Container = getContainer(hasError, isValidCoupon)
  const icon = getIcon(hasError, isValidCoupon)

  useEffect(() => {
    if (coupon.length > 0) {
      setIsTyping(true)
    } else {
      setIsTyping(false)
    }
  }, [coupon, setIsTyping])

  return (
    <Container>
      <Box>
        <CouponTextInput
          plain
          value={coupon}
          placeholder="Enter Coupon Code"
          onKeyUp={keyUpHandler}
          onChange={changeHandler}
          isValidCoupon={isValidCoupon}
          hasError={hasError}
          isTyping={isTyping}
        />
      </Box>
      <Box align="center" justify="center" direction="row">
        <ApplyButton
          plain
          disabled={isCouponEmpty}
          label="Apply"
          onClick={applyCoupon}
        />
        {icon}
      </Box>
    </Container>
  )
}

export default CouponFullInputWmo
